module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "our-clients",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('div', {
    staticClass: "title-wrapper"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('about.ourClientsTitle'))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "indentation"
  })]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.clients), function(client, index) {
    return _c('div', {
      key: index,
      staticClass: "item"
    }, [_c('img', {
      staticClass: "client-logo",
      attrs: {
        "loading": "lazy",
        "src": client.src,
        "alt": client.alt
      }
    })])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "row",
    attrs: {
      "aria-hidden": ""
    }
  }, _vm._l((_vm.clients), function(client, index) {
    return _c('div', {
      key: index,
      staticClass: "item"
    }, [_c('img', {
      staticClass: "client-logo",
      attrs: {
        "loading": "lazy",
        "src": client.src,
        "alt": client.alt
      }
    })])
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b89cd494"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Clients.vue
// module id = 308
// module chunks = 0